import { FaHouse, FaRotateLeft, FaCheck, FaArrowLeft } from "react-icons/fa6";
import { initialGhostDemands } from "../calculateGhostDemands";

function Sidebar({ resources, setResources, setView, choice, setChoice, setPicks, setProb, setResults, setJokerData, onUndo }) {
    const handleSelectResourceClick = () => {
        setView('resources');
        setResources(['coins', 'supplies']);
        setChoice(0);
        setJokerData(null);
    };

    const handleStartGameClick = () => {
        if (resources.length < 3 || resources.length > 8) return;
        setView('game');
        setChoice(1);

        let firstResources = [0, 1, 2, 3, 4];
        if (resources.length === 3) {
            firstResources = [0, 1, 2, 0, 1];
        } else if (resources.length === 4) {
            firstResources = [0, 1, 2, 3, 0];
        }
        setPicks({ 1: firstResources, 2: [], 3: [], 4: [], 5: [] });
        setProb({ 2: null, 3: null, 4: null, 5: null });
        setResults({
          1: ['Y', 'Y', 'Y', 'Y', 'Y'],
          2: ['', '', '', '', ''],
          3: ['', '', '', '', ''],
          4: ['', '', '', '', ''],
          5: ['', '', '', '', '']
        });
        setJokerData(initialGhostDemands(resources.length));
    }

    const enabled = resources.length >= 3 && resources.length <= 8;

    const btnClass = "flex items-center justify-center w-11 h-11 md:w-12 md:h-12 rounded-xl text-base md:text-lg transition-all duration-200 shadow-card";
    const glassBtn = `${btnClass} bg-white/[0.08] backdrop-blur-sm border border-white/[0.1] text-white/70 hover:text-white hover:bg-accent/60 hover:border-accent/40`;

    return (
        // Portrait phones: a centered row under the game content (hanging off the
        // card's right edge gets clipped by the screen's overflow-hidden).
        // sm+ (landscape phones, tablets, desktop): the original right-side column.
        <div className="mt-4 flex flex-row justify-center gap-2 sm:mt-0 sm:absolute sm:-right-14 sm:top-1/2 sm:-translate-y-1/2 sm:flex-col">
            { choice !== 0 && (
                <button className={glassBtn} onClick={handleSelectResourceClick} title="Home">
                    <FaHouse />
                </button>
            )}
            { choice !== 0 && (
                <button className={glassBtn} onClick={handleStartGameClick} title="Restart">
                    <FaRotateLeft />
                </button>
            )}
            { choice > 1 && (
                <button className={glassBtn} onClick={onUndo} title="Undo">
                    <FaArrowLeft />
                </button>
            )}
            { choice === 0 && (
                <button
                    disabled={!enabled}
                    className={`${btnClass} ${enabled
                        ? 'bg-accent/80 border border-accent text-white hover:bg-accent hover:shadow-glow-accent'
                        : 'bg-white/[0.04] border border-white/[0.06] text-white/20 cursor-not-allowed'}`}
                    onClick={handleStartGameClick}
                    title="Start Game">
                    <FaCheck />
                </button>
            )}
        </div>
    )
}

export default Sidebar;
